import { useBlocker } from 'react-router'

import { usePocketComponentProgressBarStateContext } from '../providers/PocketComponentProgressBarStateProvider'
import Button from './app/design/Button'
import Modal from './app/design/Modal'
import Paragraph from './app/design/Paragraph'

type Props = {
    when: boolean
    allowCurrentPaths?: (string | RegExp)[]
    allowNextPaths?: (string | RegExp)[]
}

export function NavigationBlockerPrompt({ when, allowCurrentPaths, allowNextPaths }: Props) {
    const context = usePocketComponentProgressBarStateContext()
    const isProgressBarActive = context?.isProgressBarActive

    let blocker = useBlocker(({ currentLocation, nextLocation }) => {
        if (
            allowCurrentPaths?.some((path) => currentLocation.pathname.match(path)) ||
            allowNextPaths?.some((path) => nextLocation.pathname.match(path))
        ) {
            return false
        }

        return when && currentLocation.pathname !== nextLocation.pathname && !isProgressBarActive
    })

    return (
        <Modal
            isOpen={blocker.state === 'blocked'}
            onClose={() => blocker.reset?.()}
            title="Leave this page?"
            size="small"
            showDividers={false}
            footer={
                <div className="flex items-center justify-end gap-x-4">
                    <Button onClick={() => blocker.proceed?.()} intent="primary">
                        Yes, leave
                    </Button>
                </div>
            }
        >
            <Paragraph className="text-gray-600">Your changes will not be saved.</Paragraph>
        </Modal>
    )
}
